// import React from "react";
// import moment from "moment";

// export default function JobList({ info, upcomming }) {
//   // console.log("INFO", info);
//   return <ul>{iterate(info, upcomming)}</ul>;
// }

// function iterate(data, flag) {
//   if (!data) return;
//   const bgColor = flag ? { backgroundColor: "#ffe66d" } : {};
//   return (
//     <>
//       {data.map((person, index) => {
//         Old(person.doj);
//         return (
//           <li key={index}>
//             <div className="flex">
//               <div className="title">
//                 <p className="name">
//                   <strong>{person.name}</strong>
//                 </p>
//                 <p className="name">
//                   {person.doj && moment(person.doj).format("DD-MMM")}
//                 </p>
//               </div>
//             </div>
//           </li>
//         );
//       })}
//     </>
//   );
// }

// // how old the person is
// function Old(personExperience) {
//   let year = new Date(personExperience).getFullYear();
//   let currentYear = new Date().getFullYear();
//   //   console.log(currentYear);

//   let experience = currentYear - year;
//   //   console.log(experience);
//   return experience;
// }

import React from 'react';
import moment from 'moment';

export default function JobList({ info = [], upcomming = false }) {
  return (
    <ul className='list-unstyled'>
      {info.length > 0 ? (
        info.map((person, index) => {
          const doj = person.doj ? new Date(person.doj) : null;
          const experience = getExperience(doj);
          return (
            <li key={index} className='mb-2'>
              <div
                className={`card shadow-sm border-0 ${
                  upcomming ? 'bg-warning bg-opacity-25' : 'bg-light'
                }`}
              >
                <div className='card-body d-flex align-items-center justify-content-between py-2 px-3'>
                  <div>
                    <h6
                      className='card-title mb-1 fw-semibold text-dark'
                      style={{ fontSize: '0.95rem' }}
                    >
                      {person.name}
                    </h6>
                    {doj && (
                      <p
                        className='card-text mb-0 text-muted'
                        style={{ fontSize: '0.82rem' }}
                      >
                        📅 {moment(doj).format('DD MMM')}
                      </p>
                    )}
                  </div>
                  {upcomming && (
                    <span
                      className='badge bg-warning text-dark'
                      style={{ fontSize: '0.75rem' }}
                    >
                      Upcoming
                    </span>
                  )}
                </div>
              </div>
            </li>
          );
        })
      ) : (
        <li className='text-muted text-center small'>
          No joining anniversaries found.
        </li>
      )}
    </ul>
  );
}

// Get years of experience from DOJ
function getExperience(doj) {
  if (!doj) return '';
  const dojDate = new Date(doj);
  const today = new Date();

  let experience = today.getFullYear() - dojDate.getFullYear();
  const hasCompletedThisYear =
    today.getMonth() > dojDate.getMonth() ||
    (today.getMonth() === dojDate.getMonth() &&
      today.getDate() >= dojDate.getDate());
  if (!hasCompletedThisYear) experience--;

  return experience;
}
